import { faCheck, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Alert, Button, ButtonGroup, FlexboxGrid, Modal, Tag, TagGroup } from 'rsuite';
import { authHeader } from '../../../redux/helpers';
import { axiosService } from '../../../redux/services';
import Counter from '../../../handlers/Counter/Counter';

type Props = {
    show: boolean;
    onHide: (deleted: boolean) => void;
    counters: Counter[];
};

export const DeleteCounterModal = (props: Props) => {
    const intl = useIntl();

    const [isDeleting, setIsDeleting] = useState(false);

    const handleCancel = () => {
        if (!isDeleting) {
            props.onHide(false);
        }
    };

    const handleValid = () => {
        setIsDeleting(true);

        axiosService
            .getAxios()
            .delete('/counters/tab', {
                data: { tabId: props.counters.map(counter => counter.id) },
                headers: authHeader(),
            })
            .then(() => {
                Alert.success(intl.formatMessage({ id: 'counter.delete.success' }));

                setIsDeleting(false);

                props.onHide(true);
            })
            .catch(err => {
                setIsDeleting(false);

                console.error(err);

                Alert.error(intl.formatMessage({ id: 'counter.delete.error' }));
            });
    };

    return (
        <Modal size="xs" show={props.show} onHide={handleCancel} data-cy="user-deleteuser-modal">
            <Modal.Header>
                <Modal.Title>
                    <FormattedMessage id="counter.delete.title" />
                </Modal.Title>
            </Modal.Header>
            <Modal.Body data-cy="counter-delete-modal">
                <FormattedMessage id="counter.delete.message" />

                <TagGroup>
                    {props.counters.map(counter => (
                        <Tag>
                            {counter.label} ({counter.id})
                        </Tag>
                    ))}
                </TagGroup>
            </Modal.Body>
            <Modal.Footer>
                <FlexboxGrid align="middle" justify="end">
                    <FlexboxGrid.Item>
                        <ButtonGroup>
                            <Button
                                data-cy="delete-counter-cancel"
                                onClick={handleCancel}
                                disabled={isDeleting}
                                color="red">
                                <FontAwesomeIcon icon={faTimesCircle} />
                            </Button>
                            <Button
                                data-cy="delete-counter-valid"
                                onClick={handleValid}
                                color="green"
                                loading={isDeleting}>
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                        </ButtonGroup>
                    </FlexboxGrid.Item>
                </FlexboxGrid>
            </Modal.Footer>
        </Modal>
    );
};
